import {
  FormGroup,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { getFinalOrIndicativeValueFromIndicativeObject } from '../../../product-capture/utils/get-value-from-indicative-object';
import {
  ParticipationBaseBarrierEnum,
  ParticipationBaseEnum,
} from 'src/app/product-capture/model/enums/product-capture.enums';

const INVESMENT_ALLOCATION_SUM_ERROR =
  'The sum of the initial investment and investment allocations cannot exceed 100%';

export function dropbackInvestmentLevelsValidator(): ValidatorFn {
  return (baseFormGroup: FormGroup): ValidationErrors | null => {
    const initialInvestmentValue =
      getFinalOrIndicativeValueFromIndicativeObject(
        baseFormGroup?.get(ParticipationBaseEnum.initialInvestmentAllocation)
          ?.value
      );

    const investmentAllocationsArray = baseFormGroup
      ?.get(ParticipationBaseEnum.barrier)
      ?.get(
        ParticipationBaseBarrierEnum.levelsAndInvestments
      ) as UntypedFormArray;

    const investmentAllocationSum =
      investmentAllocationsArray?.controls?.reduce((acc, control) => {
        const controlValue = getFinalOrIndicativeValueFromIndicativeObject(
          control?.value?.investmentAllocation
        );
        return acc + controlValue;
      }, 0);

    if (initialInvestmentValue + investmentAllocationSum > 100) {
      baseFormGroup
        ?.get(ParticipationBaseEnum.initialInvestmentAllocation)
        ?.setErrors({
          incorrect: true,
          message: INVESMENT_ALLOCATION_SUM_ERROR,
        });

      investmentAllocationsArray?.controls
        ?.filter(
          (control) =>
            !!control.get(ParticipationBaseBarrierEnum.investmentAllocation)
              .value
        )
        .forEach((control) => {
          control
            ?.get(ParticipationBaseBarrierEnum.investmentAllocation)
            ?.setErrors({
              incorrect: true,
              message: INVESMENT_ALLOCATION_SUM_ERROR,
            });
        });

      return {
        incorrect: true,
        message: INVESMENT_ALLOCATION_SUM_ERROR,
      };
    } else {
      baseFormGroup
        ?.get(ParticipationBaseEnum.initialInvestmentAllocation)
        ?.setErrors(null);

      investmentAllocationsArray?.controls?.forEach((control) => {
        control
          ?.get(ParticipationBaseBarrierEnum.investmentAllocation)
          ?.setErrors(null);
      });
    }

    return null;
  };
}
